module.exports = __webpack_public_path__ + "media/images/signatures/2024/janka-eb6266ef6cbf967d354c60cea4350ded.png";